import { FieldTypes } from '../../../components/FormBuilder';

export const businessList = {
  name: 'radioGroup',
  scrollToTop: false,
  orientation: 'vertical',
  variant: 'primary'
};

export const formFields = [
  {
    type: FieldTypes.RADIOGROUP,
    props: businessList
  }
];
